module.exports = __webpack_public_path__ + "static/media/jw_double_black.bf67b352.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/balloons/jw_double_black.png
// module id = 776
// module chunks = 0